export default __webpack_public_path__ + "static/media/icon-activity-edited.4a626441.svg";